import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-site-info',
  templateUrl: './footer-site-info.component.html',
  styleUrls: ['./footer-site-info.component.scss']
})
export class FooterSiteInfoComponent implements OnInit {

  constructor() { 
    // This is intentional
  }

  ngOnInit(): void {
  // This is intentional
  }

}
